/**
 * Stable fragment id for contact office cards (footer deep links + /contact#...).
 */
export function getContactOfficeAnchorId(office) {
  if (!office) return 'contact-office-unknown';
  const raw = String(office.city || office.officeName || '').trim();
  const slug = raw
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug ? `contact-office-${slug}` : `contact-office-id-${office.id}`;
}
